export default function IntroSection() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">关于无节操摄影部</h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
          无节操摄影部成立于2020年，是一个专注于创意与趣味摄影的交流社区。我们相信每一张照片都是一次独特的表达，
          无论你是刚入门的新手，还是深耕多年的专业摄影师，这里都欢迎你分享作品、交流技巧、找到同好。
          目前社区已汇聚数千位摄影爱好者，持续产出高质量的作品与教程内容。
        </p>
      </div>
    </section>
  );
}